
import Swal from "sweetalert2";
import Vue from "vue";
import {showProcessErrorMessage, showProcessPromptMessage, showProcessSuccessMessage} from "@/state/alertHelpers";
import {
    addStockToCart,
    deleteStockFromCart,
    getSingleCartList,
    updateCartPaymentMethod,
    updateCartStock
} from "@/services/modules/cart/cartService"

import store from "@/state/store";

export const state = {
    current:null,
    cartList: [],
    cartListMetaData: {},
    cartCategoryList: []
};

export const mutations = {
    addProductToCartList(state, data) {
        data.quantity = 1;
        state.cartList.push(data);
    },
    changeQuantityOfProduct(state, data) {
        let productItemInCart = state.cartList.find(e => e.stock_code == data.product.stock_code)
        if (productItemInCart) {
            if (data.definiteVal)
                productItemInCart.quantity = data.definiteVal;
            else
                productItemInCart.quantity += data.number;
            let indexProductItemInCart = state.cartList.indexOf(productItemInCart);
            Vue.set(state.cartList, indexProductItemInCart, productItemInCart);
        }
    },
    removeProductFromCartList(state, data) {
        var productItemInCart = state.cartList.find(e => e.stock_code == data.stock_code)
        if (productItemInCart) {
            let indexProductItemInCart = state.cartList.indexOf(productItemInCart);
            if (indexProductItemInCart > -1) {
                state.cartList.splice(indexProductItemInCart, 1);
            }
        }
    },
    setCartCategoryList(state, data) {
        state.cartCategoryList = data;
    },
    setCartCategoryListHeaders(state, data) {
        state.cartCategoryListHeaders = data;
    },
    setCartCategoryListLoading(state, data) {
        state.cartCategoryListLoading = data;
    },
    setCurrent(state, data){
        state.current = data
    },
    setCartList(state, data){
        state.cartList = data
    },
    setCartListMetaData(state, data){
        state.cartListMetaData = data
    }
};

export const getters = {
    getCartList(state) {
        return state.cartList;
    },
    getCurrent(state){
        return state.current;
    }
};

export const actions = {
    addProductToCartList(context, product) {
        if (context.state.cartList.includes(product)) {
            Swal.fire({
                title: "Ürün Ekleme Başarısız",
                text:
                    product.stock_name + " adlı ürün sepetinizde halihazırda bulunuyor",
                icon: "error",
                confirmButtonText: "Tamam",
            });
        }
        else {
            context.commit("addProductToCartList", product);
            Swal.fire({
                title: "Ürün Ekleme Başarılı",
                text:
                    product.stock_name + " adlı ürün sepetinize başarılı ile eklendi",
                icon: "success",
                confirmButtonText: "Tamam",
            });
        }

    },
    removeProductFromCartList(context, product) {
        Swal.fire({
            title: "Ürün Silme İşlemi",
            text: product.stock_name + " adlı ürünü silmek istediğinize emin misiniz ?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Evet",
            cancelButtonText: "Hayır"
        })
            .then(function (confirm) {
                if (confirm.isConfirmed) {
                    context.commit("removeProductFromCartList", product);
                }

            });

    },
    changeQuantityOfProduct(context, product, number = 1, definiteVal = false) {
        context.commit("changeQuantityOfProduct", product, number, definiteVal);
    },
    fetchCartCategoryList(context) {
        context.commit("setCartCategoryListLoading", true)
        setTimeout(function () {
            context.commit('setCartCategoryList', [
                {
                    id: 1,
                    title: "Kategori 1",
                    status: true
                },
                {
                    id: 2,
                    title: "Kategori 2",
                    status: false
                },
            ]);
            context.commit('setCartCategoryListHeaders', [
                {
                    key: 'title',
                    label: 'Başlık',
                    sortable: false,

                },
                {
                    key: 'status',
                    label: 'Durum',
                    sortable: true,
                    class: "text-center"

                },
                {
                    key: 'process',
                    label: 'İşlem',
                    sortable: false,
                    class: "text-center"

                }
            ]);
            context.commit("setCartCategoryListLoading", false)
        }, 2000)
    },
    async cartPaymentMethodUpdate(context,{ params, body }){
        let result = await updateCartPaymentMethod(params, body);
        if (result.data.success) {
            /*showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            });*/
        }

        return result;
    },
    async cartStockDelete(context,{ params, body }){
        await showProcessPromptMessage({
            title: 'Ürün Silme İşlemi',
            text: params.stockCode ? params.stockCode + " kodlu ürünü sepetten silmek istediğinize emin misiniz ?" : " Tüm ürünleri silmek istediğinize emin misiniz ?"
        }).then(async (confirm) => {
            if(confirm.isConfirmed)
            {
                let result = await deleteStockFromCart(params, body);
                if (result.data.success) {
                    await showProcessSuccessMessage({
                        title: 'İşlem Başarılı',
                        text: result.data.message
                    });
                }
                await context.dispatch("fetchSingleCartList",{
                        params: {},
                        body:{
                            UserId: store.state.auth.user.UserId,
                            CurrentCode: store.state.cart.current.code
                        }
                    }
                )
                return result.data.success;
            }

        });
        return false;
    },
    async cartStockUpdate(context,{ params, body }){
        let result = await updateCartStock(params, body);
        if (result.data.success) {
            showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            });
        }
        await context.dispatch("fetchSingleCartList",{
                params: {},
                body:{
                    UserId: store.state.auth.user.UserId,
                    CurrentCode: store.state.cart.current.code
                }
            }
        )
        return result;
    },
    async stockToCartAdd(context,{ params, body }){
        let result = await addStockToCart(params, body);
        if (result.data.success) {
            showProcessSuccessMessage({
                timer: 3000,
                title: 'Ürün Ekleme İşlemi Başarılı',
                text: result.data.message
            });
            await context.dispatch("fetchSingleCartList",{
                    params: {},
                    body:{
                        UserId: store.state.auth.user.UserId,
                        CurrentCode: store.state.cart.current.code
                    }
                }
            )
        }else {
            showProcessErrorMessage({
                title: 'Ürün Ekleme Başarısız',
                text: result.data.message
            });
        }

        return result;
    },
    calculateTotalQuantity(context,cartDetails) {
        const { units, denominator1, quantity } = cartDetails;

        const unitsArray = units.split(',');

        let totalAD = quantity;
        let totalKL = 0;

        if (unitsArray.includes('KL')) {
            totalKL = Math.floor(totalAD / denominator1);
            totalAD = totalAD % denominator1;
        }

        let result = "";
        if (totalKL > 0) {
            result += `${totalKL} KL (${denominator1} AD) `;
        }
        if (totalAD > 0) {
            result += ` + ${totalAD} AD`;
        }

        return result.trim();
    },
    async fetchSingleCartList(context,{ params, body }){
        let result = await getSingleCartList(params, body);
        if (result.data.success) {
            result.data.data.cartDetails.map(async (item) => {
                item.quantityInfo = await context.dispatch("calculateTotalQuantity",item);
            });
            context.commit("setCartList",result.data.data.cartDetails ? result.data.data.cartDetails : []);
            context.commit("setCartListMetaData",result.data.data ? result.data.data : {});
        }else{
            context.commit("setCartList", []);
            context.commit("setCartListMetaData", {});
        }

        return result;
    },
};
